<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/category">
        <i class="nc-icon nc-paper-2"></i>
        <p>Categories</p>
      </sidebar-link>
      <sidebar-link to="/menus">
        <i class="nc-icon nc-notes"></i>
        <p>Menus</p>
      </sidebar-link>
      <sidebar-link to="/users/all" v-if="roles.has('superadmin')">
        <i class="nc-icon nc-badge"></i>
        <p>All Users</p>
      </sidebar-link>
      <sidebar-link to="/user/profile">
        <i class="nc-icon nc-circle-09"></i>
        <p>Your Profile</p>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      roles: new Set(),
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    console.log("User", this.user.roles);
    this.user.roles.forEach((r) => {
      this.roles.add(r.name);
    });
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
